import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';

export interface IResetLoginRateLimitingOnSiteUsersParams {
  siteUserIds?: string[];
}

export interface IResetLoginRateLimitingOnSiteUsersResult extends IResult {
}

export class ResetLoginRateLimitingOnSiteUsersRequest extends Request<IResetLoginRateLimitingOnSiteUsersParams, IResetLoginRateLimitingOnSiteUsersResult> {
  constructor(params: IResetLoginRateLimitingOnSiteUsersParams) {
    super('resetLoginRateLimitingOnSiteUsers', params);
  }
}
